export function formatTimeFromSeconds(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const seconds = totalSeconds % 60;
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    const pad = (num) => num.toString().padStart(2, '0');
    return `${pad(hours)}h : ${pad(minutes)}m : ${pad(seconds)}s`;
}

export function formatTimeFromSeconds2(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    const pad = (num) => num.toString().padStart(2, '0');
    return `${pad(hours)}h: ${pad(minutes)}m `;
}